import * as React from 'react';
import styled from 'styled-components';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { SelectField } from '../../designSystem/formField/SelectField';
import { AmorgMenuOverview } from './components/AmorgMenuOverview';
import { ButtonOverview } from './components/ButtonOverview';
import { ContainerOverview } from './components/ContainerOverview';
import { ColorOverview } from './components/ColorOverview';

import { DateTimeOverview } from './components/DateTimeOverview';
import { FormFieldOverview } from './components/FormFieldOverview';
import { GraphicsOverview } from './components/GraphicsOverview';
import { IconOverview } from './components/IconOverview';
import { LayoutOverview } from './components/LayoutOverview';
import { ModalOverview } from './components/ModalOverview';
import { SelectionOverview } from './components/SelectionOverview';
import { TextInputOverview } from './components/TextInputOverview';
import { TooltipOverview } from './components/TooltipOverview';
import { TypographyOverview } from './components/TypographyOverview';
import { ListRowOverview } from './components/ListRowOverview';
import { TabOverview } from './components/TabOverview';
import { CardsOverview } from './components/CardsOverview';
import { InspectionPointOverview } from './components/InspectionPointOverview';
import { tablet } from '../../designSystem/BreakPoints';
import { FieldChangePanelOverview } from './components/FieldChangePanelOverview';
import { FormComponentsOverview } from './components/FormComponentsOverview';
import { HtmlEditorOverview } from './components/HtmlEditorOverview';
import { FileLinkCommentOverview } from './components/FileLinkCommentOverview';

const Page = styled.div`
    padding: 20px;
    margin: 50px;

    @media (max-width: ${tablet}px) {
        margin:0;
    }
`;


const Pages = ['Colors', 'Typography', 'Buttons', 'TextInput', 'Selection', 'FormField', 'DateTime', 'Cards and messages', 'Modal', 'Menu', 'Icons', 'Graphics', 'Tooltip', 'Layout', 'Containers', 'ListRow', 'Tab', 'InspectionPoints', 'FieldChangePanel', 'FormComponents', 'HtmlEditor', 'FileLinkComment'] as const;
type PageType = typeof Pages[number];

const defaultPageType: PageType = 'FieldChangePanel';

export function DesignSystem (): JSX.Element
{
    const [page, setPage] = React.useState<PageType>(() =>
    {
        // getting stored value
        const saved = localStorage.getItem("DesignSystemPage");
        return (saved || defaultPageType) as PageType;
    });

    React.useEffect(() =>
    {
        localStorage.setItem("DesignSystemPage", page);
    }, [page]);

    return (
        <ProtectedPageWrapper requiredPermissions={['UserAdmin']}>
            <Page>
                <div style={{ width: '200px', marginBottom: '10px' }}>
                    <SelectField
                        selectedValue={page}
                        options={Pages.map(p => ({ text: p, value: p })).sort((a, b) => a.text.localeCompare(b.text))}
                        onChange={newValue => setPage(newValue as PageType)}
                        label="Vælg afsnit"
                    />
                </div>

                <DesignSystemContainer>
                    {page === 'Buttons' &&
                        <ButtonOverview />
                    }
                    {page === 'Cards and messages' &&
                        <CardsOverview />
                    }
                    {page === 'Colors' &&
                        <ColorOverview />
                    }
                    {page === 'DateTime' &&
                        <DateTimeOverview />
                    }
                    {page === 'FormField' &&
                        <FormFieldOverview />
                    }
                    {page === 'Typography' &&
                        <TypographyOverview />
                    }
                    {page === 'Icons' &&
                        <IconOverview />
                    }
                    {page === 'Menu' &&
                        <AmorgMenuOverview />
                    }
                    {page === 'Modal' &&
                        <ModalOverview />
                    }
                    {page === 'Selection' &&
                        <SelectionOverview />
                    }
                    {page === 'TextInput' &&
                        <TextInputOverview />
                    }
                    {page === 'Graphics' &&
                        <GraphicsOverview />
                    }
                    {page === 'Tooltip' &&
                        <TooltipOverview />
                    }
                    {page === 'Layout' &&
                        <LayoutOverview />
                    }
                    {page === 'Containers' &&
                        <ContainerOverview />
                    }
                    {page === 'ListRow' &&
                        <ListRowOverview />
                    }
                    {page === 'Tab' &&
                        <TabOverview />
                    }
                    {page === 'InspectionPoints' &&
                        <InspectionPointOverview />
                    }
                    {page === 'FieldChangePanel' &&
                        <FieldChangePanelOverview />
                    }
                    {page === 'FormComponents' &&
                        <FormComponentsOverview />
                    }
                    {page === 'HtmlEditor' &&
                        <HtmlEditorOverview />
                    }
                    {page === 'FileLinkComment' &&
                        <FileLinkCommentOverview />
                    }

                </DesignSystemContainer>
            </Page>
        </ProtectedPageWrapper>
    );
}

const DesignSystemContainer = styled.div`
    /* border: 1px solid gray;
    border-radius: 4px;
    padding: 20px; */
`;